import { type CompliancePolicyRemoveInput, type CompliancePolicyRemoveSuccess, toResponseError } from '@terros/common'
import { type RemoveHookResponse, mutationRemove } from '../../hooks'
import { useTantalimMutation } from '../../mutation'
import { useCompliancePolicyCache } from './cache'

export function useRemoveCompliancePolicy(): RemoveHookResponse<CompliancePolicyRemoveInput> {
  const cache = useCompliancePolicyCache()

  const mutation = useTantalimMutation<CompliancePolicyRemoveInput, CompliancePolicyRemoveSuccess>({
    url: '/compliance/policy/remove',
  })

  async function remove(input: CompliancePolicyRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearItem(input.policyId, input.archive ?? true)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
